import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-ink" data-id="element-148" data-mp="uy1ik5tro8jf">
      <SiteHeader data-id="element-149" data-mp="uwgqcmuxd1oq" />
      <main className="flex-1" data-id="element-150" data-mp="78gw3cyemt5e">
        <Outlet data-id="element-151" data-mp="79ia9qapvvrc" />
      </main>
      <SiteFooter data-id="element-152" data-mp="76md446p1b3y" />
    </div>;
}